import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ViewDocumentsWrapper = styled.div`
  .content {
    margin: 0;
    padding: 0;
    width: 100%;
  }

  .document-type {
    border-bottom: 1px dashed ${COLORS.primary_light_blue4};
    ${responsive.MOBILE`
      margin-top: 16px;
    `}
  }

  .status {
    ${responsive.MOBILE`
      margin-top: 16px;
    `}
  }

  .contract-details,
  .other-details {
    row-gap: 40px;
    ${responsive.MOBILE`
      row-gap: 16px;
    `}
  }

  .document-type,
  .notes,
  .contract-details,
  .other-details {
    padding: 24px 16px;
    ${responsive.MOBILE`
      .country-multi-select {
        margin-top: 16px;
      }
      padding: 0 16px 16px 16px;
    `}
  }

  .file-upload {
    margin-left: 16px;
    ${responsive.MOBILE`
      margin-left: 16px;
      margin-right: 16px;
      width: 90%;
    `}
  }

  .notes {
    .value-style {
      word-break: break-word;
    }
  }
`;
